(function ($) {

    $(document).ready(function() {
        $('.c-tree__item--depth-2, .c-tree__item--depth-3, .c-tree__item--depth-4, .c-tree__item--depth-5').addClass('is-collapsed');

        $('.c-accordion__header--active').parents('.c-tree__item--depth-2, .c-tree__item--depth-3, .c-tree__item--depth-4, .c-tree__item--depth-5').removeClass('is-collapsed');

        $.each($('.js-accordion'), function(e) {
            if ($(this).hasClass('is-collapsed')) {
                $(this).find('.c-accordion__toggle--plusminus i').html('&#xE145;');
            } else {
                $(this).find('.c-accordion__toggle--plusminus i').html('&#xE15B;');
            }
        });
    });

    $('.js-move-dialog-reset').on('click', function(e) {
        $('.js-accordion.is-selected').removeClass('is-selected');
        $(this).closest('.js-popup').find('.c-tree__item--depth-2, .c-tree__item--depth-3, .c-tree__item--depth-4, .c-tree__item--depth-5').addClass('is-collapsed');
        $('.js-parent-selection').prop('checked', false);
        $('.c-move-content').find('.c-button').prop('disabled', true);
        $(this).closest('.js-popup').hide();
    });

    $('.js-accordion').on('click', '.js-accordion-toggle', function(e) {
        $(this).closest('.js-accordion').toggleClass('is-collapsed');
        return false;
    });

    $('.c-accordion__toggle--plusminus').on('click', function(e) {
        if ($(this).closest('.js-accordion').hasClass('is-collapsed')) {
            $(this).find('> i').html('&#xE15B;');
        } else {
            $(this).find('> i').html('&#xE145;');
        }
    });

    $('.js-accordion').on('change', '.js-parent-selection', function(e) {
        $(this).closest('.c-move-content').find('.c-button').prop('disabled', false);
        $('.js-accordion').removeClass('is-selected');
        $(this).closest('.js-accordion').addClass('is-selected');
        return false;
    });

    $('.js-popup-toggle').on('click', function() {
        $(this).siblings('.js-popup').toggle();
        return false;
    });

    $('.js-site-map-hide').on('click', function() {
        $('.js-site-map').hide();
        $('.js-moderation-list').removeClass('col-md-9').addClass('col-md-12');
    });

    $('.js-site-map-show').on('click', function() {
        $('.js-site-map').show();
        $('.js-moderation-list').removeClass('col-md-12').addClass('col-md-9');
    });
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/legacy/js/move-content.js